import React, { useContext } from 'react';
const IsLciContext = React.createContext(false);
export function useIsLci() {
    return useContext(IsLciContext);
}
export default IsLciContext;
